// extracted by mini-css-extract-plugin
export default {"cls1":"ufFhp24PpOP78PloGoXp","cls2":"rrEHyzHPBWg0l3jWsAI0 ufFhp24PpOP78PloGoXp"};